// @group Constants : Current public release shown in What's New surfaces
export const APP_RELEASE_VERSION = '1.13.0';
export const APP_RELEASE_DATE = 'October 2026';
export const APP_RELEASE_SUBTITLE = `EZ PM2 GUI · ${APP_RELEASE_DATE}`;
